// extracted by mini-css-extract-plugin
export default {"tableWrapper":"dRKbHzlYbn","tableWrapper_applySafariFix":"HjBwYXWKrI"};